$(document).ready(function(){
  // Select all links with hashes
  $('.template-page-product-usage-instruction .wt-featured-nav a[href*="#"]')
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      
      if (target.length) {
        event.preventDefault();

        var headerHeight = $('.wt-header__body').outerHeight() || 0;
        
        var scrollToPosition = target.offset().top - headerHeight - 50;

        $('html, body').animate({
          scrollTop: scrollToPosition
        }, 1000, function() {
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) {
            return false;
          } else {
            $target.attr('tabindex','-1');
            $target.focus();
          };
        });
      }
    }
  });
});